<template>
  <div>
    <div 
      v-if="isReportEnabled('fullRaceDetailsReport')" 
      :class="['reportCard', raceDetailsActive]" 
      @click="getYears()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.full-race-details-report") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('amaRaceReport')" 
      :class="['reportCard', raceActive]" 
      @click="getRaces()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.ama-race-report") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('contingencyKTMHusqvarnaGasGas')" 
      :class="['reportCard', contingencyKTMActive]" 
      @click="getContingencyKTM()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.contingency-ktm") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('contingencyOthers')" 
      :class="['reportCard', contingencyOtherActive]" 
      @click="getContingencyOther()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.contingency-other") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('rockyMountain')" 
      :class="['reportCard', rockyMountainActive]" 
      @click="getRockyMountain()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.rocky-mountain") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('awards')" 
      :class="['reportCard', awardsActive]" 
      @click="getAwards()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.awards") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('manufacturerByBrand')" 
      :class="['reportCard', manufacturerBrandActive]" 
      @click="getManufacturerBrand()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.manufacturer-brand") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('manufacturerByClasses')" 
      :class="['reportCard', manufacturerClassesActive]" 
      @click="getManufacturerClasses()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.manufacturer-classes") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('registrantThatDidnotRace')" 
      :class="['reportCard', registrantNotRaceActive]" 
      @click="getRegistrantNotRace()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.registrant-that-didnt-race") }}</div>
      <div class="cardDesc"></div>
    </div>

    <div class="v-spacer"></div>
    <v-card v-if="displayDetailsTable" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.full-race-details-report") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row>
            <v-col class="d-flex pb-0" cols="12" md="6">
              <v-autocomplete 
                v-on:change="getRacesByYearSelection()" 
                v-model="yearSelected" 
                :items="yearItems" 
                item-text="text" 
                item-value="id" 
                clearable chips
                :label="$tc('page.report.label-years')" :outlined="true" dense multiple ></v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" md="6">&nbsp;</v-col>
          </v-row>
          <v-row align="center">            
            <v-col class="d-flex pb-0" cols="12" md="6">
              <v-autocomplete 
                ref="raceDetailsSelect"
                v-on:change="getRaceDetailsReport()"
                @update:search-input="updateVisibleItems" 
                @focus="updateVisibleItems"
                v-model="raceDetailsSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                :outlined="true" 
                dense multiple clearable chips
                :disabled="yearSelected.length == 0"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="selectAllRaceDetails">
                    <v-list-item-action>
                      <v-icon>
                        {{ iconRaceDetails }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("page.report.select-all") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="raceDetailsSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="raceDetailsSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ raceDetailsSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" md="6">&nbsp;</v-col>
            <v-col class="d-flex pb-0" cols="12" md="6">
              <v-autocomplete 
                v-model="columnsSelected" 
                :items="columnsItems" 
                :label="$tc('page.report.label-columns')" 
                :outlined="true" 
                dense multiple
                :disabled="raceDetailsSelected.length == 0"
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="columnsSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="columnsSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ columnsSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" md="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" md="6">
                <v-card>
                    <v-btn v-if="tabulatorRDData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsPDF('tabulatorRD')">
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn v-if="tabulatorRDData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsCSV('tabulatorRD')">
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn :disabled="raceDetailsSelected.length == 0" color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorRD')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorRD" v-model="tabulatorRDData" :options="tabulatorRDOptions" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTable" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.ama-race-report") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="raceSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                :outlined="true" 
                dense multiple
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="raceSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="raceSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ raceSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorData.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF()"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorData.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV()"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh()">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableCK" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.contingency-ktm") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="contingencyKTMSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                outlined dense multiple
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="contingencyKTMSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="contingencyKTMSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ contingencyKTMSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataCK.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorCK')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataCK.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorCK')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorCK')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorCK" v-model="tabulatorDataCK" :options="tabulatorOptionsCK" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableCO" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.contingency-other") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="contingencyOSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                outlined dense multiple
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="contingencyOSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="contingencyOSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ contingencyOSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataCO.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorCO')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataCO.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorCO')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorCO')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorCO" v-model="tabulatorDataCO" :options="tabulatorOptionsCO" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableRM" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.rocky-mountain") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="rockyMountainSelected" 
                @change="getParticipantReportRaces({ eventId: rockyMountainSelected.id })" 
                :items="rockyMRaceItems" 
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex py-0" cols="12" sm="6">
              <!-- Select race -->
               <v-autocomplete
                v-model="eventRMSelected"
                :items="eventItemsRM"
                item-text="text"
                item-value="id"
                :label="$tc('page.report.label-event-memberships-select-race')"
                outlined dense multiple return-object
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="eventRMSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="eventRMSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ eventRMSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex py-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataRM.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorRM')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataRM.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorRM')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorRM')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorRM" v-model="tabulatorDataRM" :options="tabulatorOptionsRM" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableAW" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.awards") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0 mr-2" cols="12" sm="6">
              <v-autocomplete 
                v-model="awardSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                outlined dense
                @change="getReportAW(true)"
              ></v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete  
                v-model="seriesSelected" 
                :items="seriesItems" 
                item-text="seriesName" 
                item-value="id" 
                :label="$t('page.report.label-series-optional')" 
                outlined dense
                clearable
                :no-data-text="$t('common.no_data_set')"
                return-object
                @change="updateAwardedPositions"
              ></v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete  
                v-model="awardPositionSelected" 
                :items="awardPositionsItems" 
                :label="$t('page.report.label-series-awards-optional')" 
                outlined dense
                clearable
                :no-data-text="$t('common.no_data_set')"
              ></v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataAW.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorAW')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataAW.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorAW')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorAW')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorAW" v-model="tabulatorDataAWFiltered" :options="tabulatorOptionsAW" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableMB" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.manufacturer-brand") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="manufactBrandSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                outlined dense multiple
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="manufactBrandSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="manufactBrandSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ manufactBrandSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataMB.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorMB')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataMB.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorMB')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorMB')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorMB" v-model="tabulatorDataMB" :options="tabulatorOptionsMB" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableMC" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.manufacturer-classes") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="manufactClassesSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                outlined dense multiple
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="manufactClassesSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="manufactClassesSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ manufactClassesSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataMC.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorMC')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataMC.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorMC')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorMC')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorMC" v-model="tabulatorDataMC" :options="tabulatorOptionsMC" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayTableRNR" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.registrant-that-didnt-race") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="registrantNotRaceSelected" 
                :items="raceItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-races')" 
                outlined dense multiple
              >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="registrantNotRaceSelected.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <v-chip
                        v-if="registrantNotRaceSelected.length > 1 && index === 0"
                        class="caption"
                    >
                        <span>{{$t("page.report.filter-selections")  }} : {{ registrantNotRaceSelected.length }}</span>
                    </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex pb-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                      v-if="tabulatorDataRNR.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsPDF('tabulatorRNR')"
                    >
                    {{ $tc("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="tabulatorDataRNR.length > 0"
                      color="blue-grey" class="ma-2 white--text" 
                      @click="downloadAsCSV('tabulatorRNR')"
                    >
                    {{ $tc("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh('tabulatorRNR')">
                    {{ $tc("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulatorRNR" v-model="tabulatorDataRNR" :options="tabulatorOptionsRNR" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from 'vuex';

export default {
  mixins: [apiCalls],
  data() {
    return {
      yearSelected: [],
      yearItems: [],
      raceSelected: [],
      raceDetailsSelected: [],
      contingencyKTMSelected: [],
      contingencyOSelected: [],
      rockyMountainSelected: [],
      eventRMSelected:[],
      awardSelected: undefined,
      manufactBrandSelected: [],
      manufactClassesSelected: [],
      registrantNotRaceSelected: [],
      raceItems: [],
      eventItemsRM: [],
      rockyMRaceItems:[],
      membershipSelected:[],
      membershipItems: [],
      loadRaceItems: false,
      raceActive: "",
      raceDetailsActive: "",
      contingencyKTMActive: "",
      contingencyOtherActive: "",
      rockyMountainActive: "",
      awardsActive: "",
      manufacturerBrandActive: "",
      manufacturerClassesActive: "",
      registrantNotRaceActive: "",
      user: null,
      search: "",
      tabulatorRDData: [],
      tabulatorData: [],
      tabulatorDataCK: [],
      tabulatorDataCO: [],
      tabulatorDataRM:[],
      tabulatorDataAW: [],
      tabulatorDataMB: [],
      tabulatorDataMC: [],
      tabulatorDataRNR: [],
      displayDetailsTable: false,
      displayTable: false,
      displayTableCK: false,
      displayTableCO: false,
      displayTableRM: false,
      displayTableAW: false,
      displayTableMB: false,
      displayTableMC: false,
      displayTableRNR: false,
      eventItems:[],
      seriesSelected: undefined,
      seriesItems: [],
      awardPositionSelected: undefined,
      maxPositions: 10,
      columnsSelected: [],
      sections: [],
      itemsVisibles: []
    };
  },
  computed: {
    tabulatorOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData:true,
        columns: this.applyCaseInsensitiveToColumns([
         {
            title: this.$t("common.table.class-name"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.classPosition"),
            field: "classPosition",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.amaNumber"),
            field: "memberId",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.raceNumber"),
            field: "raceNumber",
            sorter: "alphanum",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.birthDay"),
            field: "birthday",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
          {
            title: this.$t("common.table.email"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            },
            visible: true
          },
        ], "tabulatorData")
      };
    },
    columnsRD() {
      return this.applyCaseInsensitiveToColumns([
        {
          title: this.$t("common.table.first-name"),
          field: "firstName",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("firstName")
        },
        {
          title: this.$t("common.table.last-name"),
          field: "lastName",
          sorter: "number",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("lastName")
        },
        {
          title: this.$t("common.table.amaNum"),
          field: "ama",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 90,
          visible: this.columnsSelected.includes("ama")
        },
        {
          title: this.$t("common.table.race-name"),
          field: "raceName",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("raceName")
        },
        {
          title: this.$t("common.table.raceNumber"),
          field: "number",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("number")
        },
        {
          title: this.$t("common.table.class-name"),
          field: "class",
          sorter: "string",
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          visible: this.columnsSelected.includes("class")
        },
        {
          title: this.$t("common.table.classPosition"),
          field: "classPosition",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("classPosition")
        },
        {
          title: this.$t("common.table.overallPosition"),
          field: "overallPosition",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("overallPosition")
        },
        {
          title: this.$t("common.table.score_status"),
          field: "scoresStatus",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 50,
          visible: this.columnsSelected.includes("scoresStatus")
        },
        {
          title: this.$t("common.table.total"),
          field: "total",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          visible: this.columnsSelected.includes("total")
        },
        {
          title: this.$t("common.table.gpos"),
          field: "groupPosition",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("groupPosition")
        },
        {
          title: this.$t("common.table.groupName"),
          field: "groupName",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("groupName")
        },
        {
          title: this.$t("common.table.groupPosition"),
          field: "groupPosition",
          sorter: "number",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("groupPosition")
        },
        {
          title: this.$t("common.table.checks"),
          field: "checks",
          sorter: "number",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("checks")
        },
        {
          title: this.$t("common.table.birthDay"),
          field: "birthday",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 90,
          visible: this.columnsSelected.includes("birthday")
        },
        {
          title: this.$t("common.table.email"),
          field: "email",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 160,
          formatter: "textarea",
          visible: this.columnsSelected.includes("email")
        },
        {
          title: this.$t("common.table.address"),
          field: "address",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          formatter: "textarea",
          minWidth: 110,
          visible: this.columnsSelected.includes("address")
        },
        {
          title: this.$t("common.table.city"),
          field: "city",
          sorter: "string",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("city")
        },
        {
          title: this.$t("common.table.state"),
          field: "state",
          sorter: "string",
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("state")
        },
        {
          title: this.$t("common.table.country"),
          field: "country",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("country")
        },
        {
          title: this.$t("common.table.zip"),
          field: "zip",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 60,
          formatter: "textarea",
          visible: this.columnsSelected.includes("zip")
        },
        {
          title: this.$t("common.table.behind"),
          field: "overallBehindBy",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("overallBehindBy")
        },
        {
          title: this.$t("common.table.brand"),
          field: "brand",
          sorter: "string",
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 90,
          formatter: "textarea",
          visible: this.columnsSelected.includes("brand")
        },
        {
          title: this.$t("common.table.gpos"),
          field: "groupPosition",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("groupPosition")
        },
        {
          title: this.$t("common.table.groupName"),
          field: "groupName",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("groupName")
        },
        {
          title: this.$t("common.table.groupPosition"),
          field: "groupPosition",
          sorter: "number",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("groupPosition")
        },
        {
          title: this.$t("common.table.checks"),
          field: "checks",
          sorter: "number",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          visible: this.columnsSelected.includes("checks")
        },
        {
          title: this.$t("common.table.birthDay"),
          field: "birthday",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 90,
          visible: this.columnsSelected.includes("birthday")
        },
        {
          title: this.$t("common.table.email"),
          field: "email",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 160,
          formatter: "textarea",
          visible: this.columnsSelected.includes("email")
        },
        {
          title: this.$t("common.table.address"),
          field: "address",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          formatter: "textarea",
          minWidth: 110,
          visible: this.columnsSelected.includes("address")
        },
        {
          title: this.$t("common.table.city"),
          field: "city",
          sorter: "string",
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("city")
        },
        {
          title: this.$t("common.table.state"),
          field: "state",
          sorter: "string",
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("state")
        },
        {
          title: this.$t("common.table.country"),
          field: "country",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("country")
        },
        {
          title: this.$t("common.table.zip"),
          field: "zip",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 60,
          formatter: "textarea",
          visible: this.columnsSelected.includes("zip")
        },
        {
          title: this.$t("common.table.behind"),
          field: "overallBehindBy",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("overallBehindBy")
        },
        {
          title: this.$t("common.table.avgSpeed"),
          field: "avgSpeed",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("avgSpeed")
        },
        {
          title: this.$t("common.table.avgTime"),
          field: "avgTime",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          visible: this.columnsSelected.includes("avgTime")
        },
        {
          title: this.$t("common.table.bestTime"),
          field: "bestTime",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          visible: this.columnsSelected.includes("bestTime")
        },
        {
          title: this.$t("common.table.brand"),
          field: "brand",
          sorter: "string",
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 90,
          formatter: "textarea",
          visible: this.columnsSelected.includes("brand")
        },
        {
          title: this.$t("common.table.membershipType"),
          field: "membershipType",
          sorter: "string",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          headerVertical: true,
          minWidth: 100,
          formatter: "textarea",
          visible: this.columnsSelected.includes("membershipType")
        }
      ].concat(this.sections.map(el => ({
        title: `${this.$t("common.table.section")} ${el.section}`,
        field: el.field,
        sorter: "string",
        headerFilter: "input",
        headerFilterPlaceholder: " ",
        headerVertical: true,
        minWidth: 80,
        formatter: "textarea",
        visible: this.columnsSelected.includes(el.field)
      }))), "tabulatorRDData");
    },
    columnsItems() {
      return this.columnsRD.map(col => ({
        value: col.field,
        text: col.title
      }));
    },
    tabulatorRDOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData:true,
        columns: this.columnsRD,
      };
    },
    tabulatorOptionsCK() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        columns: this.applyCaseInsensitiveToColumns([
          {
            title: this.$t("common.table.class-name"),
            field: "className",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.classPosition"),
            field: "classPosition",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.email"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          }
        ], "tabulatorDataCK"),
      };
    }, 
    tabulatorOptionsCO() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData:true,
        columns: this.applyCaseInsensitiveToColumns([
          {
            title: this.$t("common.table.classPosition"),
            field: "classPosition",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.class-name"),
            field: "className",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("common.table.brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          }
        ], "tabulatorDataCO"),
      };
    }, 
    tabulatorOptionsAW() { 
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          { column: "classPosition", dir: "asc" },
          { column: "name", dir: "asc" }
        ],
        columns: this.applyCaseInsensitiveToColumns([          
          
        {
            title: this.$t("common.table.classPosition"),
            field: "classPosition",
            sorter: function(a, b) {
              if (!isNaN(a) && !isNaN(b)) {
                return Number(a) - Number(b);
              }
              if (!isNaN(a)) return 1;
              if (!isNaN(b)) return -1;
              return a.localeCompare(b);
            },
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.class-name"),
            field: "name",
            sorter: function(a, b, aRow, bRow) {
              const orderA = aRow.getData().sortOrder ?? 999999;
              const orderB = bRow.getData().sortOrder ?? 999999;
              if (orderA === orderB) {
                return aRow.getData().name.localeCompare(bRow.getData().name);
              }
              return orderA - orderB;
            },
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.phone"),
            field: "phone",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.address"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.zip"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          }
        ], "tabulatorDataAW"),
      };
    },
    tabulatorOptionsRM() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        columns: this.applyCaseInsensitiveToColumns([
          {
            title: this.$t("page.report.label-event-memberships-firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("page.report.label-event-memberships-lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ", 
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("page.report.label-event-memberships-mailingAddress"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("page.report.label-event-memberships-city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("page.report.label-event-memberships-state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("page.report.label-event-memberships-zipcode"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t("page.report.label-event-memberships-emailAddress"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea",
            sorterParams:{
              alignEmptyValues: "bottom"
            }
          },
        ], "tabulatorDataRM"),
      };
    }, 
    tabulatorOptionsMB() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData:true,
        columns: this.applyCaseInsensitiveToColumns([
          {
            title: this.$t("common.table.brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.class-name"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.count-classes"),
            field: "countClasses",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          }
        ], "tabulatorDataMB"),
      };
    },
    tabulatorOptionsMC() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData:true,
        columns: this.applyCaseInsensitiveToColumns([
          {
            title: this.$t("common.table.class-name"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
            
          },
          {
            title: this.$t("common.table.count-brand"),
            field: "countBrand",
            sorter: "number",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
        ], "tabulatorDataMC"),
      };
    },
    tabulatorOptionsRNR() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData:true,
        columns: this.applyCaseInsensitiveToColumns([
          {
            title: this.$t("common.table.first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.number"),
            field: "number",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.class-name"),
            field: "className",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          }
        ], "tabulatorDataRNR"),
      };
    }, 
    awardPositionsItems() {
      // If there are no maxPositions, return empty array
      if (!this.maxPositions) return [];

        // Create array from 1 to maxPositions
      return Array.from({length: this.maxPositions}, (_, i) => i + 1);
    },
    tabulatorDataAWFiltered() {
      if (this.awardPositionSelected) {
        // Group data by class name to maintain class grouping
        const groupedData = this.tabulatorDataAW.reduce((acc, item) => {
          if (!acc[item.name]) {
            acc[item.name] = [];
          }
          acc[item.name].push(item);
          return acc;
        }, {});

        // For each class, take only the first N positions
        const filteredData = Object.values(groupedData).flatMap(classGroup => {
          // Sort by classPosition - letters first, then numbers
          const sorted = classGroup.sort((a, b) => {
            const isANumber = !isNaN(a.classPosition);
            const isBNumber = !isNaN(b.classPosition);
            
            // If both are letters or both are numbers
            if (isANumber === isBNumber) {
              if (isANumber) {
                // Both are numbers - sort numerically
                return Number(a.classPosition) - Number(b.classPosition);
              } else {
                // Both are letters - sort alphabetically
                return a.classPosition.localeCompare(b.classPosition);
              }
            }
            
            // One is letter, one is number - letters come first
            return isANumber ? 1 : -1;
          });
          
          // Return only the first N positions for each class
          return sorted.slice(0, this.awardPositionSelected);
        });

        return filteredData;
      }
      return this.tabulatorDataAW;
    },
    iconRaceDetails () {
      if (this.likesAllRaceDetails) return 'fas fa-check-square'
      if (this.likesSomeRaceDetails) return 'fas fa-minus-square'
      return 'far fa-square'
    },
    likesAllRaceDetails() {
      const filtered = this.itemsVisibles;
      if (filtered.length === 0) return false;
      return filtered.every(item => this.raceDetailsSelected.includes(item.id));
    },
    
    likesSomeRaceDetails() {
      const filtered = this.itemsVisibles;
      const selectedInFilter = filtered.filter(item => 
        this.raceDetailsSelected.includes(item.id)
      );
      return selectedInFilter.length > 0 && selectedInFilter.length < filtered.length;
    },
    ...mapState({
      reportConfig: (state) => state.reports.reportConfig
    })
  },
  methods: {
    normalizeCaseValue(value) {
      return (value ?? "")
        .toString()
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },
    getCaseInsensitiveMultiselectFilter(field, sourceKey = "tabulatorData") {
      return {
        headerFilterFunc: (headerValue, rowValue) => {
          const selectedValues = Array.isArray(headerValue) ? headerValue : (headerValue ? [headerValue] : []);
          if (!selectedValues.length) return true;
          const normalizedRowValue = this.normalizeCaseValue(rowValue);
          return selectedValues.map((value) => this.normalizeCaseValue(value)).includes(normalizedRowValue);
        },
        headerFilterParams: {
          values: () => {
            const sourceMap = {
              tabulatorData: this.tabulatorData,
              tabulatorRDData: this.tabulatorRDData,
              tabulatorDataCK: this.tabulatorDataCK,
              tabulatorDataCO: this.tabulatorDataCO,
              tabulatorDataRM: this.tabulatorDataRM,
              tabulatorDataAW: this.tabulatorDataAW,
              tabulatorDataMB: this.tabulatorDataMB,
              tabulatorDataMC: this.tabulatorDataMC,
              tabulatorDataRNR: this.tabulatorDataRNR,
            };
            const tableData = sourceMap[sourceKey] || [];
            const unique = new Set();
            tableData.forEach((row) => {
              const normalized = this.normalizeCaseValue(row?.[field]);
              if (normalized) unique.add(normalized);
            });
            return Array.from(unique).sort();
          },
          sortValuesList: "asc",
          multiselect: true
        }
      };
    },
    applyCaseInsensitiveToColumns(columns, sourceKey = "tabulatorData") {
      const targetFields = new Set(["className", "class", "name", "brand", "city", "state", "status"]);
      return (columns || []).map((column) => {
        if (column?.columns && Array.isArray(column.columns)) {
          return {
            ...column,
            columns: this.applyCaseInsensitiveToColumns(column.columns, sourceKey),
          };
        }
        if (!column?.field || !targetFields.has(column.field)) return column;
        return {
          ...column,
          headerFilter: "select",
          ...this.getCaseInsensitiveMultiselectFilter(column.field, sourceKey),
          headerFilterPlaceholder: column.headerFilterPlaceholder ?? " ",
        };
      });
    },
    updateVisibleItems() {
      this.$nextTick(() => {
        const componente = this.$refs.raceDetailsSelect;
        if (componente) {
          const rawItems = componente.filteredItems || [];
          this.itemsVisibles = rawItems.map(item => item.raw || item);
        }
      });
    },    
    selectAllRaceDetails() {
      const filtered = this.itemsVisibles;
      if (this.likesAllRaceDetails) {
        const filteredIds = filtered.map(i => i.id);
        this.raceDetailsSelected = this.raceDetailsSelected.filter(
          id => !filteredIds.includes(id)
        );
      } else {
        const filteredIds = filtered.map(i => i.id);
        const combined = [...this.raceDetailsSelected, ...filteredIds];
        this.raceDetailsSelected = [...new Set(combined)];
      }
    },
    async getRacesByYearSelection(){
      this.loadRaceItems = false;
      this.raceDetailsSelected = [];
      const response = await this.api("get", "/api/v1/users/current");
      const { success, message } = response;
      if (success) {
          this.user = message;
          const yearSelectedString = this.yearSelected.map(item => item.toString());
          const response1 = await this.api("get", `/api/v1/promoter/race/${this.user.id}/${yearSelectedString}`);
          const success1 = response1.success;
          const message1 = response1.message;
          if (success1) {
            this.raceItems = message1.map((item) => {
              return {
                id: item.raceId,
                text: `${item.eventDate} :: ${this.$escapeHtml.decode(item.eventName)} :: ${this.$escapeHtml.decode(item.raceName)}`
              };
            });
            this.loadRaceItems = true;
          } 
      }
    },
    async getYears(){
      this.raceDetailsActive = "";
      this.displayDetailsTable = false;
      if(this.raceDetailsActive == "active"){
        this.raceDetailsActive = "";
        this.displayDetailsTable = false;
      } else {
        this.raceDetailsActive = "active";
        this.displayDetailsTable = true;
      }
      this.loadRaceItems = false;

      const response = await this.api("get", "/api/v1/users/current");
      const { success, message } = response;
      if (success) {
          this.user = message;
          const response1 = await this.api("get", `/api/v1/promoter/race-years/${this.user.id}`);
          const success1 = response1.success;
          const message1 = response1.message;
          if(success1) {
              this.yearItems = message1.map((item) => {
                  return {
                      id: item.year,
                      text: item.year
                  };
              });
          }
      }
    },
    resetAwardPositionValue() {
      if(!this.awardPositionSelected) this.awardPositionSelected = 10;
    },
    refresh(indexO = 'tabulator') {
      switch(indexO) {
        case 'tabulator': this.getReport(true);
          break;
        case 'tabulatorCK': this.getReportCKTM(true);
          break;
        case 'tabulatorCO': this.getReportCO(true);
          break;
        case 'tabulatorRM': this.getRockyMountainReport({ raceId: this.eventRMSelected }, true);
          break;
        case 'tabulatorAW': this.getReportForSeriesAwards();
          break;
        case 'tabulatorMB': this.getReportMB(true);
          break;
        case 'tabulatorMC': this.getReportMC(true);
          break;
        case 'tabulatorRD': this.getRaceDetailsReport(true);
          break;
        case 'tabulatorRNR': this.getReportRNR(true);
          break;
      }
    },
    async loadRaces() {
      const response = await this.api("get", "/api/v1/users/current");
      const { success, message } = response;
      if (success) {
          this.user = message;
          const response1 = await this.api("get", `/api/v1/promoter/race/${this.user.id}`);
          const success1 = response1.success;
          const message1 = response1.message;
          if(success1) {
              this.raceItems = message1.map((item) => {
                  return {
                      id: item.raceId,
                      text: `${item.eventDate} :: ${this.$escapeHtml.decode(item.eventName)} :: ${this.$escapeHtml.decode(item.raceName)}`
                  };
              });
              this.loadRaceItems = true;
          }
      }
    },
    async loadRacesRM() {
      const response = await this.api("get", "/api/v1/promoter/event/hasraces");

      this.rockyMRaceItems = [
        {
          id: "-1",
          text: this.$t("common.form.select-an-option"),
          disabled: true
        },
        ...response.map(event => ({
          id: event.id,
          text: this.$escapeHtml.decode(event.eventName)
        }))
      ];
    },
    getRaceDetails() {
      this.raceActive = this.contingencyKTMActive = this.contingencyOtherActive = this.rockyMountainActive = this.awardsActive = this.manufacturerBrandActive = this.manufacturerClassesActive = this.registrantNotRaceActive = "";
      this.displayTable = this.displayTableCK = this.displayTableCO = this.displayTableRM = this.displayTableAW = this.displayTableMB = this.displayTableMC = this.displayTableRNR = false;
        if(this.raceDetailsActive == "active"){
            this.raceDetailsActive = "";
            this.displayDetailsTable = false;
        } else {
            this.raceDetailsActive = "active";
            this.displayDetailsTable = true;
        }
        if(!this.loadRaceItems)
          this.loadRaces();
    },
    getRaces() {
        this.contingencyKTMActive = this.contingencyOtherActive = this.rockyMountainActive = this.awardsActive = this.manufacturerBrandActive = this.manufacturerClassesActive = this.raceDetailsActive = this.registrantNotRaceActive = "";
        this.displayDetailsTable = this.displayTableCK = this.displayTableCO = this.displayTableRM = this.displayTableAW = this.displayTableMB = this.displayTableMC = this.displayTableRNR = false;
        if(this.raceActive == "active"){
            this.raceActive = "";
            this.displayTable = false;
        } else {
            this.raceActive = "active";
            this.displayTable = true;
        }
        if(!this.loadRaceItems)
          this.loadRaces();
    },
    getContingencyKTM() {
      this.raceActive = this.contingencyOtherActive = this.rockyMountainActive = this.awardsActive = this.raceDetailsActive = this.manufacturerBrandActive = this.manufacturerClassesActive = this.registrantNotRaceActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCO = this.displayTableRM = this.displayTableAW = this.displayTableMB = this.displayTableMC = false;
      if(this.contingencyKTMActive == "active"){
          this.contingencyKTMActive = "";
          this.displayTableCK = false;
      } else {
          this.contingencyKTMActive = "active";
          this.displayTableCK = true;
      }
      if(!this.loadRaceItems)
          this.loadRaces();
    },
    getContingencyOther() {
      this.raceActive = this.contingencyKTMActive = this.rockyMountainActive = this.awardsActive = this.raceDetailsActive = this.manufacturerBrandActive = this.manufacturerClassesActive = this.registrantNotRaceActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCK = this.displayTableRM = this.displayTableAW = this.displayTableMB = this.displayTableMC = this.displayTableRNR = false;
      if(this.contingencyOtherActive == "active"){
          this.contingencyOtherActive = "";
          this.displayTableCO = false;
      } else {
          this.contingencyOtherActive = "active";
          this.displayTableCO = true;
      }
      if(!this.loadRaceItems)
          this.loadRaces();
    },
    getRockyMountain(){
      this.raceActive = this.contingencyKTMActive = this.contingencyOtherActive = this.awardsActive = this.raceDetailsActive = this.manufacturerBrandActive = this.manufacturerClassesActive = this.registrantNotRaceActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCK = this.displayTableCO = this.displayTableAW = this.displayTableMB = this.displayTableMC = this.displayTableRNR = false;
      if(this.rockyMountainActive == "active"){
          this.contingencyOtherActive = "";
          this.displayTableRM = false;
      } else {
          this.rockyMountainActive = "active";
          this.displayTableRM = true;
      }
      this.loadRacesRM();
    },
    getAwards(){
      this.raceActive = this.contingencyKTMActive = this.contingencyOtherActive = this.rockyMountainActive = this.raceDetailsActive = this.manufacturerBrandActive = this.manufacturerClassesActive = this.registrantNotRaceActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCK = this.displayTableCO = this.displayTableRM = this.displayTableMB = this.displayTableMC = this.displayTableRNR = false;
      if(this.awardsActive == "active"){
          this.awardsActive = "";
          this.displayTableAW = false;
      } else {
          this.awardsActive = "active";
          this.displayTableAW = true;
      }
      if(!this.loadRaceItems)
        this.loadRaces();
    },
    getManufacturerBrand() {
      this.raceActive = this.contingencyKTMActive = this.contingencyOtherActive = this.rockyMountainActive = this.raceDetailsActive = this.manufacturerClassesActive = this.awardsActive = this.registrantNotRaceActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCK = this.displayTableCO = this.displayTableRM = this.displayTableAW = this.displayTableMC = this.displayTableRNR = false;
      if(this.manufacturerBrandActive == "active"){
          this.manufacturerBrandActive = "";
          this.displayTableMB = false;
      } else {
          this.manufacturerBrandActive = "active";
          this.displayTableMB = true;
      }
      if(!this.loadRaceItems)
        this.loadRaces();
    },
    getManufacturerClasses() {
      this.raceActive = this.contingencyKTMActive = this.contingencyOtherActive = this.rockyMountainActive = this.raceDetailsActive = this.manufacturerBrandActive = this.registrantNotRaceActive = this.awardsActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCK = this.displayTableCO = this.displayTableRM = this.displayTableAW = this.displayTableMB = this.displayTableRNR = false;
      if(this.manufacturerClassesActive == "active"){
          this.manufacturerClassesActive = "";
          this.displayTableMC = false;
      } else {
          this.manufacturerClassesActive = "active";
          this.displayTableMC = true;
      }
      if(!this.loadRaceItems)
        this.loadRaces();
    },
    getRegistrantNotRace() {
      this.raceActive = this.contingencyKTMActive = this.contingencyOtherActive = this.rockyMountainActive = this.raceDetailsActive = this.manufacturerBrandActive = this.awardsActive = this.manufacturerClassesActive = "";
      this.displayDetailsTable = this.displayTable = this.displayTableCK = this.displayTableCO = this.displayTableRM = this.displayTableAW = this.displayTableMB = this.displayTableMC = false;
      if(this.registrantNotRaceActive == "active"){
          this.registrantNotRaceActive = "";
          this.displayTableRNR = false;
      } else {
          this.registrantNotRaceActive = "active";
          this.displayTableRNR = true;
      }
      if(!this.loadRaceItems)
        this.loadRaces();
    },
    async getRockyMountainReport(data, refreshReport = false) {
      if(refreshReport) {
        this.tabulatorDataRM = [];
        const tabulatorInstance = this.$refs.tabulatorRM.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(this.eventRMSelected && Array.isArray(data.raceId) && data.raceId.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/participant`, { raceId: data.raceId.map((item) => item.id) });
            this.tabulatorDataRM = response;
        } else {
          this.tabulatorDataRM = [];
          //ALL: show notification 
          let msgAlert = '';
          if(!this.rockyMountainSelected || this.rockyMountainSelected.length == 0) {
            msgAlert = this.$t('page.report.notifications.select-event-required');
          } else if(!data.raceId || data.raceId.length == 0) {
            msgAlert = this.$t('page.report.notifications.select-races-required');
          }
          this.$store.commit('reports/SET_MSG_ALERT', msgAlert);
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorDataRM = [];
      }
    },
    async getMembershipReport(filter = null) {
      let data = {};
      data.report = "eventSelfReg";

      if (filter != null) {
        data.filter = filter;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/memberships", data);

      //select for events
      this.eventItemsRM = response.filters[0].filter.data;
      this.eventRMSelected.id = response.filters[0].selected;

      response.filters[1].filter.data.forEach(
        function (e, i) {
          let replaceText = this.$t("page.report.label-event-memberships-select-organization-item-text").replace("{_ORG_}", response.filters[1].filter.data[i].text);
          response.filters[1].filter.data[i].text = replaceText;
        }.bind(this)
      );

      //select for memberships
      this.membershipItems = response.filters[1].filter.data;
      this.membershipSelected.id = response.filters[1].selected;

      //the table data
      this.tabulatorDataRM = response.results;
    },
    async getParticipantReportRaces(data) {
      const response = await this.api("get", `/api/v1/promoter/event/${data.eventId}/races`);

      this.eventRMSelected = [];
      this.eventItemsRM = response.map(race => ({
        id: race.id,
        text: this.$escapeHtml.decode(race.raceName)
      }));
    },
    async getReportAW(refreshReport = false){
      
      if(refreshReport) {
        const tabulatorInstance = this.$refs.tabulatorAW.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(this.awardSelected) {
            await this.loadSeriesForRace();
            this.seriesSelected = undefined;
            this.awardPositionSelected = 10;
        } else {
          this.tabulatorDataAW = [];
          this.seriesItems = [];
          //ALL: show notification 
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-race-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        //this.tabulatorDataAW = [];
        this.seriesItems = [];
      }
    },
    async getReportForSeriesAwards() {
      this.tabulatorDataAW = [];
      const tabulatorInstance = this.$refs.tabulatorAW.getInstance();
      tabulatorInstance.clearHeaderFilter();
      
      // Reset sorting before loading new data
      tabulatorInstance.clearSort();
      
      // Optionally, reapply initial sorting
      tabulatorInstance.setSort([
        { column: "classPosition", dir: "asc" },
        { column: "name", dir: "asc" }
      ]);

      if(this.awardSelected) {
        const isFindSeries = () => {
            if (!this.seriesSelected || !this.seriesSelected.id) return false;
            return !!this.seriesItems.find(item => item.id === this.seriesSelected.id);
        };
        const response = await this.api(
          "post", 
          `/api/v1/promoter/reports/events/race/awards`, 
          { 
            raceId: [ this.awardSelected ], 
            ...(isFindSeries() && { seriesId: [ this.seriesSelected.id ] })
          });
          const { results } = response;
          this.tabulatorDataAW = results;
      } else {
        this.getReportAW();
        //ALL: show notification 
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-race-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
      }
    },
    async getReport(refreshReport = false) {
      if(refreshReport) { 
        this.tabulatorData = [];
        const tabulatorInstance = this.$refs.tabulator.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(Array.isArray(this.raceSelected) && this.raceSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/ama`, { raceId: this.raceSelected });
            const { results } = response;
            this.tabulatorData = results;
        } else {
          this.tabulatorData = [];
          //ALL: show notification 
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorData = [];
      }
    },
    async getReportCKTM(refreshReport = false) {
      if(refreshReport) {
        this.tabulatorDataCK = [];
        const tabulatorInstance = this.$refs.tabulatorCK.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(Array.isArray(this.contingencyKTMSelected) && this.contingencyKTMSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/contingency`, { raceId: this.contingencyKTMSelected });
            const { results } = response;
            this.tabulatorDataCK = results;
        } else {
          this.tabulatorDataCK = [];
          //ALL: show notification 
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorDataCK = [];
      }
        
    },
    async getReportCO(refreshReport = false) {
      if(refreshReport) {
        this.tabulatorDataCO = [];
        const tabulatorInstance = this.$refs.tabulatorCO.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(Array.isArray(this.contingencyOSelected) && this.contingencyOSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/contingency`, { raceId: this.contingencyOSelected });
            const { results } = response;
            this.tabulatorDataCO = results;
        } else {
          this.tabulatorDataCO = [];
          //ALL: show notification 
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorDataCO = [];
      }
    },
    async getReportMB(refreshReport = false) {
      if(refreshReport) {
        this.tabulatorDataMB = [];
        const tabulatorInstance = this.$refs.tabulatorMB.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(Array.isArray(this.manufactBrandSelected) && this.manufactBrandSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/manufacturerBrand`, { raceId: this.manufactBrandSelected });
            const { results } = response;
            this.tabulatorDataMB = results;
        } else {
          this.tabulatorDataMB = [];
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorDataMB = [];
      }
    },
    async getReportMC(refreshReport = false) {
      if(refreshReport) {
        this.tabulatorDataMC = [];
        const tabulatorInstance = this.$refs.tabulatorMC.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(Array.isArray(this.manufactClassesSelected) && this.manufactClassesSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/manufacturerClasses`, { raceId: this.manufactClassesSelected });
            const { results } = response;
            this.tabulatorDataMC = results;
        } else {
          this.tabulatorDataMC = [];
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorDataMC = [];
      }
    },
    async getRaceDetailsReport(refreshReport = false) {
      if(refreshReport) {
        this.tabulatorRDData = [];
        const tabulatorInstance = this.$refs.tabulatorRD.getInstance();

        try {
          tabulatorInstance.clearHeaderFilter();
        } catch {/*-----*/}
        
        if(Array.isArray(this.raceDetailsSelected) && this.raceDetailsSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/results`, { raceId: this.raceDetailsSelected });
            const { results } = response;
            this.processColumns(response);
            this.tabulatorRDData = results;
        } else {
          this.tabulatorRDData = [];
          //ALL: show notification 
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      }/* else {
        this.tabulatorRDData = [];
      } */
    },
    async getReportRNR(refreshReport = false) {
      if(refreshReport) {
        this.tabulatorDataRNR = [];
        const tabulatorInstance = this.$refs.tabulatorRNR.getInstance();
        tabulatorInstance.clearHeaderFilter();
        if(Array.isArray(this.registrantNotRaceSelected) && this.registrantNotRaceSelected.length > 0) {
            const response = await this.api("post", `/api/v1/promoter/reports/events/race/norun`, { raceId: this.registrantNotRaceSelected });
            const { results } = response;
            this.tabulatorDataRNR = results;
        } else {
            this.tabulatorDataRNR = [];
            this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-options-required'));
            this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      } else {
        this.tabulatorDataRNR = [];
      }
      
    },
    cleanData(data) {
      return data.map(row => {
        const newRow = {};
        for (const key in row) {
          if (key === "sections" && Array.isArray(row.sections)) {
            newRow.sections = row.sections.map(section => {
              const cleanSection = {};
              for (const secKey in section) {
                cleanSection[secKey] = (section[secKey] === null || section[secKey] === undefined) ? "" : section[secKey];
              }
              return cleanSection;
            });
          } else {
            newRow[key] = (row[key] === null || row[key] === undefined) ? "" : row[key];
          }
        }
        return newRow;
      });
    },
    selectIndexData(indexO = 'tabulator') {
      const dataTable = {
        tabulator: 'tabulatorData',
        tabulatorRD: 'tabulatorRDData',
        tabulatorCK: 'tabulatorDataCK',
        tabulatorCO: 'tabulatorDataCO',
        tabulatorRM: 'tabulatorDataRM',
        tabulatorAW: 'tabulatorDataAWFiltered',
        tabulatorMB: 'tabulatorDataMB',
        tabulatorMC: 'tabulatorDataMC',
        tabulatorRNR: 'tabulatorDataRNR',
      };
      return dataTable[indexO];
    },
    downloadAsPDF(indexO = 'tabulator') {
      const indexTable = this.selectIndexData(indexO);
      const tabulatorInstance = this.$refs[indexO].getInstance();
      const cleanData = this.cleanData(this[indexTable]);
      tabulatorInstance.replaceData(cleanData);
      setTimeout(() => tabulatorInstance.downloadToTab("pdf"), 500);
    },
    downloadAsCSV(indexO = 'tabulator') {
      const indexTable = this.selectIndexData(indexO);
      const tabulatorInstance = this.$refs[indexO].getInstance();
      const cleanData = this.cleanData(this[indexTable]);
      tabulatorInstance.replaceData(cleanData);
      tabulatorInstance.download("csv", "data.csv", {
        delimiter: ",",
      });
    },
    async loadSeriesForRace() {
      if (this.user && this.awardSelected) {
          const response = await this.api("get", `/api/v1/promoter/race/${this.user.id}/series/${this.awardSelected}`);
          if(response.success) {
            const { series, registrationCountMaxByClass } = response.message;
            this.seriesItems = series;
            this.maxPositions = registrationCountMaxByClass;
          } else {
            this.seriesItems = [];
          }
      } else {
        this.seriesItems = [];
      }
    },
    isReportEnabled(reportId) {
      return this.reportConfig.races.reports.find(report => report.name === reportId && report.isEnabled) || false;
    },
    async updateAwardedPositions() {
      if(this.seriesSelected) {
        try {
          const response = await this.api("get", `/api/v1/promoter/race/${this.user.id}/series/${this.awardSelected}/maxPositions/${this.seriesSelected.id}`);
          this.maxPositions = response;
        } catch {
          this.maxPositions = 10;
        }
      } else {
        this.seriesSelected = undefined;
        this.loadSeriesForRace();
      }
    },
    setDefaultColumnsSelected() {
      this.columnsSelected = this.columnsRD.slice(0, 10).map(col => col.field);
    },
    processColumns(response) {
      
      const { results } = response;
      let countSections = results.map((el) => {
          return el.sections.length;
      });
      const maxCount = Math.max(...countSections);
      let field = '';
      let i = 0;
      const filterSections = (el) => {
        const match = el.match(/^sections\.(\d+)\.totalSectionTime$/);
        if (match) {
          const idx = parseInt(match[1], 10);
          return idx < maxCount;
        }
        return true;
      };
      this.sections = this.sections.filter((el) => filterSections(el.field));
      this.columnsSelected = this.columnsSelected.filter((el) => filterSections(el));
      for(i = 0; i < maxCount; i++) {
        field = `sections.${i}.totalSectionTime`;
        if(!this.sections.map(el => el.field).includes(field)) {
          this.sections.push({
            indexTitle: "common.table.section",
            field,
            section: i + 1
          });
        }
        if(!this.columnsSelected.includes(field)) this.columnsSelected.push(field);
      }
    }
  },
  created() {
    this.setDefaultColumnsSelected();
  },
  mounted() { 
    this.isReportEnabled('') 
    this.getYears();
    this.$nextTick(() => {
      this.updateVisibleItems();
    });
  }, 
  watch: {
    tabulatorDataAWFiltered() {
      this.$refs.tabulatorAW.getInstance().redraw();
    },
    awardPositionsItems() {
      if(!this.awardPositionSelected) {
        this.awardPositionSelected = 10;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.fal,
.far {
  font-family: "Font Awesome 5 Pro";
}

.fal {
  font-weight: 300;
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard .cardDesc {
  width: 80%;
}

/*.v-card__title {
  background-color: #ddd;
  color: #333;
}*/

.reportCard {
  text-align: left;
}

.pdl8 {
  padding-left: 8px;
}
</style>
